/**
 * Поле fix в /market/records = base_gross_salary (годовой gross, ₽).
 * STI — доля (0.15 = 15%).
 */

export function marketFixAnnualToMonthly(fixAnnual: number): number {
  return fixAnnual / 12;
}

/** Годовая total compensation: base × (1 + STI). */
export function marketTotalCompensationAnnual(fixAnnual: number, stiFraction: number): number {
  return fixAnnual * (1 + stiFraction);
}
